<template>
    <Dialog :visible="visible" modal :style="{ width: '50rem' }" :closable="false">  
        <template #header>
            <div class="flex justify-content-between w-full">
                <h3>Modifica giorno Sessione</h3>
                <Button icon="pi pi-times" @click="closeDialog" class="p-button-text p-button-rounded p-button-secondary"/>
            </div>
        </template>
        Seleziona il nuovo giorno  
        <div class="m-2">
            <label class="mr-2">Giorno</label>
            <Calendar v-model="slot.time_in" dateFormat="dd/mm/yy" :manualInput="false" :style="{width:'155px'}"/>
        </div>
     
        <p class="p-3"><label>Clicca qui se vuoi cambiare questo campo per tutte le sessioni di questo giorno della settimana da ora in poi<br/></label>
        <input type="checkbox"  v-model="forever"/>
        </p>
      
        <template #footer>
            <Button label="Salva" @click="save"/>
        </template>
    </Dialog>
</template>

<script>
import { ref, watch } from 'vue';
import Dialog from 'primevue/dialog';
import Button from 'primevue/button';
import moment from 'moment'

export default {
    name: 'DialogComponentData',
    components: {
        Dialog,
        Button
    },
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        day: {
            type: String,
            required: true
        },
       
    },
    setup(props, { emit }) {
        const forever = ref(false)
        const slot = ref({});
        
        watch(() => props.day, (newVal) => {
            console.log("newVal")
            console.log(newVal)
            slot.value.time_in = new Date(newVal);//new Date(newVal) ;
           
        });
        
        const closeDialog = () => {
            emit('close');
        };
        const save = () => {
            let formattedTime = moment(slot.value.time_in).format('Y-MM-DD');

            emit('save',  formattedTime,forever.value);
          
            closeDialog();
        };
        return {
            closeDialog,
            save,forever,slot
        };
    }
};
</script>

<style scoped>
</style>
